exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guest-table table thead tr th {\n  font-size: 1rem;\n}\n.thline {\n  background-color: #2f1b7a !important;\n  color: white !important;\n}\n", ""]);

// exports
